import { Image, useComponentTheme } from '@vmos2/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import pluralize from 'pluralize';
import { LoyaltyLogo } from './loyaltyLogo';

type Props = {
  slug: string,
};

export const LoyaltyAdvert = ({ slug }: Props) => {
  const { t } = useTranslation('loyalty');
  const { image } = useComponentTheme(theme => theme.components.LoyaltyAdvert);
  const description = t('authDescription', { slug: pluralize(slug) });
  const title = t('here');

  return (
    <LoyaltyWrapper data-test="loyalty-advert" showBackgroundColour={!image}>
      {image ? (
        <ImageWrapper alt={`${title} ${description}`} src={image} />
      ) : (
        <>
          <div>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </div>
          <LogoWrapper>
            <LoyaltyLogo />
          </LogoWrapper>
        </>
      )}
    </LoyaltyWrapper>
  );
};

const Description = styled('span')`
  :not(:empty) {
    display: block;
    margin-top: ${({ theme }) => theme.margins.xs};
  }
`;

const ImageWrapper = styled(Image)`
  max-width: 100%;
`;

const LoyaltyWrapper = styled('div')`
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ showBackgroundColour, theme }) =>
    showBackgroundColour && (theme.color.loyalty.description || theme.color.brand)};
  color: ${({ theme }) => theme.color.white};
  margin-bottom: 24px;
  ${({ showBackgroundColour }) => showBackgroundColour && 'padding: 24px;'}
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${({ theme }) => theme.breakpoint.desktop}) {
    margin: 0 0 24px;
    ${({ showBackgroundColour }) => showBackgroundColour && 'padding: 32px;'}
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

const LogoWrapper = styled('div')`
  flex: none;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.color.backgroundLogo || theme.color.white};
  color: ${({ theme }) => theme.color.loyalty.logo || theme.color.brand};
  width: 40px;
  height: 40px;
  padding: 8px;
  margin: 0 0 0 32px;

  @media (${({ theme }) => theme.breakpoint.desktop}) {
    width: 80px;
    height: 80px;
    padding: 16px;
  }
`;

const Title = styled('h2')`
  margin: 0;
`;
